<template>
  <div
    class="biBarWrap biLineWrap"
    ref="biLineWrap">
    <svg
      v-if="data && data.length"
      ref="svg"
      :width="clientWidth"
      :height="clientHeight"
      :class="{'biChartBlur': refresh !== 0}">
      <bi-label
        :data="classes.data"
        :options="classes.options"
        @classesClick="classesClick"/>
      <g
        class="area"
        ref="area">
        <g
          class='scroll'
          ref="scroll">
          <g
            class="helpLinear"
            ref="helpLinear"/>
          <rect
            class="hoverRect"
            fill="#F3F3F3"
            opacity="0"
            :x="left"
            :y="top"
            :height="innerHeight"/>
          <g
            class="rect"
            ref="rect"/>
          <g
            class="axisX"
            ref="axisX"/>
        </g>
        <g
          class="axisY"
          ref="axisY"/>
      </g>
      <g
        class="focusBar"
        ref="focusBar"
        opacity="0">
        <rect
          :x="left"
          :y="top"
          :width="innerWidth"
          :height="innerHeight"
          @mouseover="opacityFocus(1)"
          @mouseout="opacityFocus(0)"
          @mousemove="inventFocus"/>
      </g>
      <defs>
        <clipPath :id="hashId">
          <rect
            :width="innerWidth"
            :height="innerHeight + 1"
            :x="left"
            :y="top - 1"/>
        </clipPath>
      </defs>
    </svg>
    <div
      class="center-p"
      v-show="refresh === 0 && !(classes.data.length) || refresh === 1 || refresh === 2 || refresh === 3">
      <el-tag type="warning"><i
        class="el-icon-loading"
        v-show="refresh === 1"/>{{ message[refresh] }}</el-tag>
      <el-button
        type="primary"
        size="mini"
        @click="reload"
        v-show="refresh === 0">
        <i class="el-icon-refresh"/>点击刷新
      </el-button>
    </div>
    <bi-tool-tip
      class="tooltip"
      :data="tooltip"/>
  </div>
</template>

<script>
import * as d3 from 'd3';
import Common from '@/components/charts/common';

export default {
  mixins: [Common],
  data() {
    return {
      defaultOptions: {
        width: 0,
        height: 0,
        margin: {
          top: 50, right: 24, bottom: 20, left: 40
        },
        domainType: 'number',
        domainX: null,
        domainY: null,
        curve: '',
        groupType: true,
        exLabel: '%%',
        duration: 400,
        labelWidthPercent: 25,
        defaultBarWidth: 0,
        helpLine: false,
        fontSize: '12px'
      },
      scrollX: 0,
      bar: {
        defaultBarWidth: 30,
        barStep: 0,
      },
      init: false,
    };
  },
  props: {},
  computed: {
    scaleX() {
      let scale;
      if (this.option.domainX) {
        switch (this.option.domainType) {
          case 'time':
            scale = d3.scaleTime().range([this.left, this.dataWidth + this.left]);
            break;
          case 'string':
            scale = d3.scaleBand().range([this.left, this.dataWidth + this.left])
              .domain(this.option.domainX);
            break;
          default:
            scale = d3.scaleLinear().range([this.left, this.dataWidth + this.left])
              .domain(d3.extent(this.option.domainX, d => d));
        }
      }
      return scale;
    }
  },
  methods: {
    createSvg() {
      if (this.data.length === 0) return;
      this.initData();
    },
    createAllAttr() {
      d3.select(this.$refs.axisX).selectAll('*').remove();
      d3.select(this.$refs.axisY).selectAll('*').remove();
      d3.select(this.$refs.rect).selectAll('*').remove();
      d3.select(this.$refs.helpLinear).selectAll('*').remove();
      // 画轴
      // this.scaleX.domain(this.option.domainX);
      let classes = this.classes.data;
      // 这里只计算分组柱，叠柱形式还未计算
      let values = [];
      if (this.groupType) {
        values = this.data.map((d) => {
          if (this.getLabelStatus(d.class, classes)) {
            return d.value;
          }
          return 0;
        });
      } else {
        this.data.map((d) => {
          if (this.getLabelStatus(d.class, classes)) {
            if (!values[d.label]) {
              values[d.label] = 0;
            }
            values[d.label] += d.value;
          }
          return 0;
        });
        values = d3.values(values);
      }

      let max = d3.max(values, d => d) || 1;
      // let imax = max.toString().split('');
      // max = imax.map((a, i) => {
      //   if (!i) {
      //     if (typeof a[1] !== 'undefined' && parseInt(imax[1], 10) > 3) {
      //       a = parseInt(a, 10) + 1;
      //     }
      //   } else if (i === 1 && parseInt(a, 10) <= 3) {
      //     a = parseInt(a, 10) + 1;
      //   } else {
      //     a = 0;
      //   }
      //   return a;
      // }).join('');
      this.yLeft = (max.toString().split('').length + 2) * 7;
      this.scaleY.domain([0, max]);
      // if (this.options.defaultBarWidth) {
      //   this.bar.defaultBarWidth = this.options.defaultBarWidth;
      // }
      d3.select(this.$refs.axisX)
        .attr('transform', `translate(0, ${this.bottom})`)
        .call(d3.axisBottom(this.scaleX));
      let styleStr = `font-size:${this.option.fontSize};`;
      d3.select(this.$refs.axisX).selectAll('text').attr('style', styleStr);
      let tick = (max / 5) | 0;
      tick = tick > 2 ? 5 : max;
      tick = max < 2 ? 5 : tick;
      d3.select(this.$refs.axisY)
        .attr('transform', `translate(${this.left}, 0)`)
        .call(d3.axisLeft(this.scaleY).ticks(tick).tickFormat((d) => {
          d = this.option.exY === '%' ? d * 100 : d;
          // return `${d}${this.option.exY}`;
          return `${d}`;
          // return this.option.exY ? `${d * 100}${this.option.exY}` : d;
        }));
      // 如果存在辅助线
      if (this.option.helpLine) {
        let helpLine = d3.select(this.$refs.helpLinear).attr('style', 'stroke-dasharray:5;stroke-dashoffset:1');
        let y1 = this.top + 5;
        let iy = (this.bottom - y1) / 4;
        let ys = [y1, y1 + iy, y1 + (2 * iy), y1 + (3 * iy)];
        ys.map((y) => {
          helpLine
            .append('line')
            .attr('x1', this.left)
            .attr('y1', y)
            .attr('x2', this.right)
            .attr('y2', y)
            .attr('stroke', '#D2D2D2')
            .attr('style', 'font-size:14px')
            .attr('stroke-width', '1px');
          return y;
        });
      }
      let { barWidth } = this.option;
      const domainX = this.option.domainX;
      this.bar.barStep = this.dataWidth / domainX.length; // 实际刻度的长度
      let myBarWidth = this.getTrueNum(this.bar.barStep, barWidth); // 实际矩形宽度
      // this.bar.defaultBarWidth = myBarWidth;
      // 每组数据矩形数量，叠柱始终为1
      let num = this.option.groupType ? d3.sum(this.classes.data.map(d => +d.status)) : 1;
      // 返回加工好的数据
      this.bar = Object.assign({}, this.bar, {
        barWidth: myBarWidth,
        barLeft: (this.bar.barStep - (myBarWidth * num)) / 2
      });
    },
    // 每一个rect是通过左上角坐标定位的
    initData() {
      if (this.option.domainX && this.option.domainY) {
        this.createAllAttr();
      } else {
        // 输出一个无数据的效果
        return null;
      }
      // this.svg = d3.select(this.$refs.rect);
      const { barWidth, barLeft } = this.bar;
      // let i = 0;
      let rect = d3.select(this.$refs.rect);
      rect.attr('clip-path', `url(#${this.hashId})`);
      this.update = rect.selectAll('.rect').data(this.data).remove();
      let enter = this.update.enter();
      // let exit = this.update.exit();

      if (this.option.groupType) {
        // 普通分组矩形绘画
        enter
          .append('rect')
          .attr('fill', d => this.getColor(d.class, this.classes.data))
          .attr('class', d => `rect${d.label}`)
          .attr('x', (d) => {
            // 普通计算横轴位移
            let width = this.scaleX(d.label)
              + (this.getRealIndex(d.class, this.classes.data) * barWidth);
            return width + barLeft;
          })
          .attr('width', barWidth)
          .attr('y', this.bottom)
          .attr('height', 0)
          // .attr('rx', 4)
          .transition()
          .duration(this.duration)
          .attr('y', (d) => {
            return this.scaleY(d.value);
          })
          .attr('height', (d) => {
            return this.getLabelStatus(d.class, this.classes.data)
              ? this.bottom - this.scaleY(d.value) : 0;
          })
          .ease(d3.easeElastic);
      } else {
        // 叠柱绘画
        let groupRect = [];
        enter
          .append('rect')
          .attr('fill', d => this.getColor(d.class, this.classes.data))
          .attr('class', d => `rect${d.label}`)
          .attr('x', (d) => {
            // 普通计算横轴位移
            return this.scaleX(d.label) + barLeft;
          })
          .attr('width', () => {
            return barWidth;
          })
          .attr('y', this.bottom)
          .attr('height', 0)
          // .attr('rx', 4)
          .transition()
          .duration(this.duration)
          .attr('y', (d) => {
            let y = d.value;
            if (groupRect[d.label]) {
              y = groupRect[d.label] + d.value;
            }
            if (this.getLabelStatus(d.class, this.classes.data)) {
              groupRect[d.label] = (groupRect[d.label] ? groupRect[d.label] : 0) + y;
            }
            return this.scaleY(y);
          })
          .attr('height', (d) => {
            return this.getLabelStatus(d.class, this.classes.data)
              ? this.bottom - this.scaleY(d.value) : 0;
          })
          .ease(d3.easeElastic);
      }
      // this.inventFocus();
      let drag = d3.drag();
      let focusBar = d3.select(this.$refs.focusBar);
      let dwidth = this.dataWidth;
      let width = this.innerWidth;
      focusBar
        .call(drag
          .on('drag', () => {
            let rect = d3.select(this.$refs.scroll).select('.rect');
            let xAxis = d3.select(this.$refs.scroll).select('.axisX');
            let scrollX = this.scrollX + d3.event.dx;
            this.scrollX = Math.min(0, scrollX);
            this.scrollX = Math.max(-(dwidth - width), this.scrollX);
            rect
              .selectAll('rect')
              .attr('transform', `translate(${this.scrollX}, 0)`);
            xAxis
              .attr('transform', `translate(${this.scrollX}, ${this.bottom})`);
          }));
    },
    opacityFocus(opacity) {
      d3
        .select(this.$refs.focusBar)
        .transition()
        .duration(this.duration / 2)
        .attr('opacity', opacity || 0);
      d3
        .select(this.$refs.biLineWrap)
        .select('.tooltip')
        .transition()
        .duration(this.duration / 2)
        .style('opacity', opacity || 0);
      d3
        .select(this.$refs.scroll)
        .select('.hoverRect')
        .attr('width', this.scaleX.bandwidth())
        .attr('opacity', opacity || 0);
    },
    inventFocus(e) {
      if (this.data.length === 0) return;
      let mouseX = e.layerX - this.left;
      let index = ((mouseX - this.scrollX) / this.bar.barStep);
      let x1 = this.option.domainX[index | 0];
      x1 && d3
        .select(this.$refs.scroll)
        .select('.hoverRect')
        .transition()
        .duration(this.duration / 3)
        .attr('x', this.scaleX(x1) + this.scrollX);
      this.tooltip = {
        panelWidth: this.innerWidth,
        desc: [],
      };
      this.data.forEach((d) => {
        if (d.label === x1) {
          let label = this.getLabel(d.class, this.classes.data);
          if (label.status && d.value) {
            label.value = d.value;
            this.tooltip.desc.push(label);
          }
        }
      });
      this.tooltip.x = e.layerX;
      this.tooltip.y = e.layerY;
      this.tooltip.title = this.option.exLabel.replace(/%%/, x1);
    },
    classesClick(ix) {
      this.classes.data = this.changeClassStatus(ix, this.classes.data);
      this.initData();
    },
    getRealIndex(text, classes) {
      let index = 0;
      if (classes) {
        for (let i = 0; i < classes.length; i++) {
          if (classes[i].title === text) {
            break;
          }
          if (classes[i].status) {
            index++;
          }
        }
      }
      return index;
    }
  },
  watch: {
    data() {
      this.scrollX = 0;
      this.$nextTick(() => {
        if (this.option.classes) {
          this.classes.data = this.option.classes.map((d, i) => {
            return {
              title: d,
              color: this.colors[i],
              type: 'bar',
              status: true,
              view: true
            };
          });
          this.classes.options = {
            panelWidth: this.clientWidth,
            labelWidthPercent: this.option.labelWidthPercent
          };
        }
        if (!this.init) {
          this.createSvg();
          this.init = true;
        } else {
          this.initData();
        }
      });
    }
  }
};
</script>

<style>
.biBarWrap {
  position: relative;
  height: 100%;
}

.biChartBlur {
  opacity: .25;
  filter: blur(12px);
}

.biBarWrap svg {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.biBarWrap .axis path,
.biBarWrap .axis line {
  fill: none;
  stroke: black;
  shape-rendering: crispEdges;
}

.biBarWrap .center-p {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.biBarWrap .center-p .state {
  position: relative;
  z-index: 100;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.biBarWrap .center-p button {
  margin-top: 20px;
}

.biBarWrap .focusBar rect {
  fill: none;
  pointer-events: all;
}
</style>
